/**
 * View component for /nodes/new
 *
 * Creates a new node from a copy of the defaultItem in the node reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sceneActions from '../../scene/sceneActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as nodeActions from '../nodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import node components
import NodeForm from '../components/NodeForm.js.jsx';
import NodeLayout from '../components/NodeLayout.js.jsx';

class CreateNode extends Base {
  constructor(props) {
    super(props);
    this.state = {
      node: { ...this.props.defaultNode }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(sceneActions.fetchListIfNeeded());
    dispatch(contentModuleActions.fetchListIfNeeded());
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newNodeState = _.update( this.state.node, e.target.name, function() {
      return e.target.value;
    });
    this.setState({node :newNodeState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(nodeActions.sendCreateNode(this.state.node)).then((action) => {
      if(action.success) {
        dispatch(nodeActions.invalidateList());
        history.push(`/nodes/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { node } = this.state;
    const { sceneStore , contentModuleStore } = this.props;
    const isEmpty = false; //(node._scene === null || node._scene === undefined);
    return (
      <NodeLayout>
        <div className="flex">
          <section className="section">
            { isEmpty ?
                <h2> Loading...</h2>
              :
                <NodeForm
                  cancelLink="/nodes"
                  formTitle="Create Node"
                  formType="create"
                  handleFormChange={this._handleFormChange}
                  handleFormSubmit={this._handleFormSubmit}
                  node={node}
                  sceneStore={sceneStore}
                  contentModuleStore={contentModuleStore}
                />
            }
          </section>
        </div>
      </NodeLayout>
    )
  }
}

CreateNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultNode: store.node.defaultItem
    , sceneStore: store.scene
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateNode)
);



// WEBPACK FOOTER //
// modules/node/views/CreateNode.js.jsx